import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { useState } from 'react';

const DestinationOriginToggleComponent = ({alignment, setAlignment}) => {
  const handleAlignment = (event, newAlignment) => {
    if (newAlignment !== null) {
      setAlignment(newAlignment);
    }
  };

  return (
    <ToggleButtonGroup
      color='primary'
      value={alignment}
      exclusive
      onChange={handleAlignment}
      aria-label='Platform'>
      <ToggleButton value='to'>Προς</ToggleButton>
      <ToggleButton value='from'>Από</ToggleButton>
    </ToggleButtonGroup>
  );
};

export default DestinationOriginToggleComponent;
